// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__20_Wv","left":"StickyBox_left__FkTjR","right":"StickyBox_right__3RfF4"};